// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1AFiK","title":"BackImages_title__WreNm","images":"BackImages_images__1lWlm"};